import { render } from "./SettingsForm.vue?vue&type=template&id=475c8763"
import script from "./SettingsForm.vue?vue&type=script&lang=js"
export * from "./SettingsForm.vue?vue&type=script&lang=js"

import "./SettingsForm.vue?vue&type=style&index=0&id=475c8763&lang=css"

import exportComponent from "/home/runner/work/fpv-raffle/fpv-raffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__